var PdfPanel = {
    pdfBuilder: function(successHandler, errorHandler) {
        // Setup Fabrics
        FabricPanel.prepareFabricPayload();

        var data = {
            "selectedSource":"Richardson Customizer",
            "selectedTemplate":"Richardson",
            "searchKey": Math.random().toString(36).substring(2, 15) + "-RCY-" + new Date().getFullYear(),
            "thumbnails": ub.current_material.settings.thumbnails,
            "category": ub.config.sport,
            "fullName": ub.user ? ub.user.fullname : "Guest User",
            "client": ub.user ? ub.user.fullname : "Guest User",
            "orderId": ub.current_material.settings.design_number_magento,
            "sml": ub.data.modifierLabels,
            "foid":"",
            "description": ub.config.description,
            "cutPdf": ub.current_material.settings.cut_pdf,
            "stylesPdf": ub.current_material.settings.styles_pdf,
            "roster": ub.current_material.settings.roster,
            "pipings": ub.current_material.settings.pipings,
            "createdDate": moment().format('LL'),
            "notes":"",
            "sizeBreakdown": ub.current_material.settings.size_breakdown,
            "applications": ub.current_material.settings.applications,
            "sizingTable":"",
            "upper": ub.config.type === "upper" ? ub.current_material.settings.upper : "",
            "lower": ub.config.type === "lower" ? ub.current_material.settings.lower : "",
            "hiddenBody": ub.current_material.settings.hiddenBody,
            "randomFeeds": ub.funcs.isSocks() ? ub.current_material.settings.randomFeeds: "",
            "legacyPDF":"",
            "applicationType": ub.config.uniform_application_type,
            "approval": {
                "signature": null,
                "dateTimeStamp": null,
                "disabled": true
            },
            "brandLogo": ""
        };

        if (typeof ub.current_material.settings.userFullName !== "undefined") {
            data.fullName = ub.current_material.settings.userFullName;
            data.client = ub.current_material.settings.userFullName;
        }

        // Setup Brand Logo 
        LogoPanel.utilities.generateRLogoThumbnail(function(logo) {
            // Assign BrandLogo
            data.brandLogo = logo;
            PdfPanel.postPdf(data, successHandler, errorHandler);
        });
    },

    postPdf: function(data, successHandler, errorHandler) {
        var url = ub.config.pdf_host + "/api/upload";
        
        $.ajax({
            url: url,
            type: "POST",
            data: JSON.stringify(data),
            dataType: "json",
            crossDomain: true,
            contentType: 'application/json',
            headers: {
                "accessToken": null
            },
            success: successHandler,
            error: errorHandler
        });
    },

    regeneratePdf: function(callback) {
        ub.utilities.info("Generating PDF");
        PdfPanel.pdfBuilder(function(response) {
            if (response.success) {
                ub.current_material.settings.uniformPreviewPdf = response.pdfUrl;
                ub.current_material.settings.pdfOrderForm = response.pdfUrl;

                if (_.isFunction(callback)) {
                    callback();
                }
            } else {
                var error = "Something went wrong while updating youre PDF. Please try again later.";
                ub.funcs.showNotification(error, "danger", 3000);

                if (_.isFunction(callback)) {
                    callback();
                }
            }
        }, function(err) {
            var error = "Something went wrong while updating youre PDF. Please try again later.";
            ub.funcs.showNotification(error, "danger", 3000);
            
            if (_.isFunction(callback)) {
                callback();
            }
        });
    }
};